module.exports = __webpack_public_path__ + "static/feature-cloud-native-965e769367470ce067c6ec964dee8a3e.png";